import { useState, useEffect } from "react";
import {
  Layout,
  Drawer,
  FloatButton,
  Button,
  Spin,
  Space,
  Input,
  Dropdown,
  Modal,
  List,
  message,
  Typography,
} from "antd"; // เพิ่ม message
import {
  UpOutlined,
  RollbackOutlined,
  AppstoreOutlined,
  DownOutlined,
} from "@ant-design/icons";
import axios from "axios";
import { COLOR } from "../../utils/theme";
import Sidenav from "./Sidenav";
import Header from "./Header";
import Router from "./Router";
import { useNavigate, useLocation } from "react-router-dom"; // เพิ่ม useLocation
import { useSearch } from "../pages/contractDetail/hook/SearchContext";
import {
  POST_SEARCH_CONTRACT_LAWYER,
  HEADERS_EXPORT_DETAIL,
  POST_SEARCH_CONTRACT_REGNO,
  HEADERS_EXPORT_BEN,
} from "../API/apiUrls";

const { Header: AntHeader, Content } = Layout;

function Main() {
  const [visible, setVisible] = useState(false);
  const [titleName, setTitleName] = useState("หน้าแรก");
  const navigate = useNavigate();
  const location = useLocation(); // ใช้ติดตามการเปลี่ยนเส้นทาง
  const [loading, setLoading] = useState(false);
  const [titleHistory, setTitleHistory] = useState(["หน้าแรก"]);
  // สำหรับค้นหา
  const [searchInput, setSearchInput] = useState("");
  const { handleSearch } = useSearch(); //ใช้ Context

  // สำหรับค้นหาจากชื่อ-นามสกุล / เลขบัตร (modal)
  const [isNameSearchOpen, setIsNameSearchOpen] = useState(false);
  const [nameSearchType, setNameSearchType] = useState(1); // 1 = ชื่อ-สกุล, 2 = เลขบัตร
  const [nameSearchLoading, setNameSearchLoading] = useState(false);
  const [nameSearchResults, setNameSearchResults] = useState([]);

  // ========================================
  //Event Handlers
  // ========================================
  const openDrawer = () => setVisible(!visible);

  const handleMenuClick = (title) => {
    console.log("title", title);

    if (typeof title === "string") {
      setTitleName(title);
      setTitleHistory((prev) => [...prev, title]);
    }
    setVisible(false);
  };

  const handleMenuBack = () => {
    setLoading(true);
    navigate(-1);

    const timer = setTimeout(() => {
      setTitleHistory((prev) => {
        if (prev.length <= 1) return prev;
        const newHistory = [...prev];
        newHistory.pop();
        const lastTitle = newHistory[newHistory.length - 1];
        setTitleName(lastTitle || "หน้าแรก");
        return newHistory;
      });
      setLoading(false);
    }, 150);

    return () => clearTimeout(timer); // เคลียร์ timeout ถ้ามีการเปลี่ยนหน้าก่อนทำงานเสร็จ
  };

  const handleMenuHome = () => {
    setLoading(true);
    setTitleName("หน้าแรก");
    navigate("/");
    setLoading(false);
  };

  //ฟังก์ชันค้นหาจากเลขสัญญา (logic เดิม)
  const onSearch = () => {
    console.log("searchInput", searchInput);

    if (!searchInput.trim()) {
      message.warning("กรุณากรอกเลขสัญญา");
      return;
    }

    // ส่งค่าไป Context
    handleSearch({
      CONTNO: searchInput.trim(),
    });
  };

  //ค้นหาจากชื่อ-นามสกุล / เลขบัตร ผ่าน POST_SEARCH_CONTRACT_LAWYER โดยใช้คำค้นหาจากช่องค้นหาเดิม
  const runNameCardSearch = async (searchType) => {
    console.log("searchType", searchType);

    if (!searchInput.trim()) {
      message.warning(
        searchType === 1
          ? "กรุณากรอกชื่อ-นามสกุล ในช่องค้นหา"
          : searchType === 2
            ? "กรุณากรอกเลขบัตรประชาชน ในช่องค้นหา"
            : "กรุณากรอกเลขทะเบียน ในช่องค้นหา",
      );
      return;
    }
    let api;
    let payload;
    let header;
    if (searchType === 3) {
      api = POST_SEARCH_CONTRACT_REGNO;
      payload = {
        REGNO: searchInput.trim(),
      };
      header = HEADERS_EXPORT_BEN;
    } else {
      api = POST_SEARCH_CONTRACT_LAWYER;
      payload = {
        search_type: searchType,
        keyword: searchInput.trim(),
      };
      header = HEADERS_EXPORT_DETAIL;
    }

    setNameSearchType(searchType);
    setNameSearchResults([]);
    setIsNameSearchOpen(true);
    setNameSearchLoading(true);
    try {
      const { data } = await axios.post(api, payload, { headers: header });

      if (searchType === 3) {
        setNameSearchResults(data ?? []);
      } else {
        setNameSearchResults(data?.data ?? []);
      }

      if (data?.data?.length || data?.length) {
        message.success("ค้นหาสำเร็จ");
      } else {
        message.info("ไม่พบข้อมูลที่ค้นหา");
        setIsNameSearchOpen(false);
      }
    } catch (error) {
      console.error("Error runNameCardSearch:", error);
      message.error("เกิดข้อผิดพลาดในการค้นหา");
    } finally {
      setNameSearchLoading(false);
    }
  };

  //เลือกรายการที่ค้นหาเจอ แล้วค้นหาสัญญาตาม logic เดิม
  const handleSelectNameSearchResult = (record) => {
    if (nameSearchType === 3) {
      handleSearch({ CONTNO: record.CONTNO });
    } else {
      handleSearch({ CONTNO: record.newContno });
    }

    setIsNameSearchOpen(false);
  };

  const searchMenuItems = [
    {
      key: "CONTNO",
      label: "ค้นหาจากเลขสัญญา",
      onClick: onSearch,
    },
    {
      key: "NAME",
      label: "ค้นหาจากชื่อ-นามสกุล",
      onClick: () => runNameCardSearch(1),
    },
    {
      key: "CARD",
      label: "ค้นหาจากเลขบัตร",
      onClick: () => runNameCardSearch(2),
    },
    {
      key: "REGNO",
      label: "ค้นหาจากทะเบียนรถ",
      onClick: () => runNameCardSearch(3),
    },
  ];

  useEffect(() => {
    const handleEsc = (event) => {
      if (event.key === "Escape" && visible) {
        setVisible(false);
      }
    };
    window.addEventListener("keydown", handleEsc);
    return () => window.removeEventListener("keydown", handleEsc);
  }, [visible]);

  return (
    <Layout style={{ minHeight: "100vh", background: "#f0f2f5" }}>
      <Drawer
        title={false}
        placement="left"
        closable={false}
        onClose={() => setVisible(false)}
        open={visible}
        width={280}
        styles={{ body: { padding: 0 } }}
        className="drawer-sidebar"
        style={{ backgroundColor: "rgba(0, 0, 0, 0.45)" }}
      >
        <Sidenav color={COLOR.primary} onClick={handleMenuClick} />
      </Drawer>

      <Modal
        title={
          nameSearchType === 1
            ? `ผลการค้นหาจากชื่อ-นามสกุล : ${searchInput}`
            : nameSearchType === 2
              ? `ผลการค้นหาจากเลขบัตรประชาชน : ${searchInput}`
              : `ผลการค้นหาจากเลขทะเบียน : ${searchInput}`
        }
        open={isNameSearchOpen}
        onCancel={() => setIsNameSearchOpen(false)}
        footer={null}
        width={640}
      >
        <List
          loading={nameSearchLoading}
          dataSource={nameSearchResults}
          locale={{ emptyText: "ไม่มีข้อมูล" }}
          style={{ maxHeight: 400, overflowY: "auto" }}
          renderItem={(item) => (
            <List.Item
              key={`${item.CUSCOD}-${item.newContno}`}
              style={{ cursor: "pointer" }}
              onClick={() => handleSelectNameSearchResult(item)}
              actions={[
                <Button size="small" type="link">
                  เลือก
                </Button>,
              ]}
            >
              <List.Item.Meta
                title={
                  nameSearchType !== 3
                    ? item.full_name
                    : `${item.SNAM}${item.NAME1} ${item.NAME2}`
                }
                description={
                  <span onClick={(e) => e.stopPropagation()}>
                    เลขบัตร:{" "}
                    <Typography.Text copyable>{item.CUSCOD}</Typography.Text> |
                    เลขสัญญา:{" "}
                    <Typography.Text copyable>
                      {item.newContno || item.CONTNO}
                    </Typography.Text>
                  </span>
                }
              />
              {typeof item.BALANC === "number" && (
                <div>{item.BALANC.toLocaleString()} บาท</div>
              )}
            </List.Item>
          )}
        />
      </Modal>

      <Layout style={{ minHeight: "100vh" }}>
        <AntHeader
          style={{
            padding: 0,
            background: "#fff",
            position: "sticky",
            top: 0,
            zIndex: 998,
            boxShadow: "0 2px 8px rgba(0,0,0,0.06)",
            width: "100%",
          }}
        >
          <Header onPress={openDrawer} title={titleName} />
        </AntHeader>

        <Content
          className="content-ant"
          style={{
            padding: "12px 16px", // ลด padding บนเพื่อให้ปุ่มย้อนกลับดูเด่น
            minHeight: "calc(100vh - 64px)",
            background: "#f0f2f5",
          }}
        >
          <Spin spinning={loading} size="large" tip=" Loading... ">
            {location.pathname !== "/" && (
              <div
                style={{
                  marginBottom: 12,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between", // ⭐ เพิ่มบรรทัดนี้!
                }}
              >
                {/* ซ้ายสุด */}
                <Space>
                  <Button
                    type="text"
                    icon={
                      <RollbackOutlined style={{ color: COLOR.secondary }} />
                    }
                    onClick={() => handleMenuBack(titleHistory)}
                    style={{
                      display: "flex",
                      alignItems: "center",
                      color: COLOR.secondary,
                      fontWeight: "600",
                      background: "#fff",
                      borderRadius: "8px",
                      boxShadow: "0 2px 4px rgba(0,0,0,0.05)",
                    }}
                  >
                    ย้อนกลับ
                  </Button>
                  <Button
                    type="text"
                    icon={
                      <AppstoreOutlined style={{ color: COLOR.secondary }} />
                    }
                    onClick={() => handleMenuHome()}
                    style={{
                      display: "flex",
                      alignItems: "center",
                      color: COLOR.secondary,
                      fontWeight: "600",
                      background: "#fff",
                      borderRadius: "8px",
                      boxShadow: "0 2px 4px rgba(0,0,0,0.05)",
                    }}
                  >
                    หน้าแรก
                  </Button>
                </Space>
                {(location.pathname === "/search/contarct-detail" ||
                  location.pathname === "/search/contarct-detail-new") && (
                  <Space size={10} wrap>
                    <Input
                      placeholder="ค้นหาสัญญา"
                      value={searchInput}
                      onChange={(e) => setSearchInput(e.target.value)}
                      onPressEnter={() => onSearch()} // ✅ เพิ่มบรรทัดนี้
                      style={{
                        width: "auto",
                        borderRadius: "8px",
                      }}
                      size="small"
                      suffix={<span style={{ marginRight: 5 }}>🔍</span>}
                    />

                    <Dropdown
                      menu={{ items: searchMenuItems }}
                      trigger={["click"]}
                      placement="bottomRight"
                    >
                      <Button
                        size="large"
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: 6,
                          color: COLOR.secondary,
                          fontWeight: "600",
                          background: "#fff",
                          borderRadius: "8px",
                          boxShadow: "0 2px 4px rgba(0,0,0,0.05)",
                        }}
                      >
                        ค้นหา <DownOutlined />
                      </Button>
                    </Dropdown>
                  </Space>
                )}
              </div>
            )}

            <div
              style={{
                background: "#fff",
                padding: 24,
                borderRadius: 12,
                minHeight: "100%",
                boxShadow: "0 2px 8px rgba(0,0,0,0.06)",
              }}
            >
              <Router onMenuClick={handleMenuClick} onBack={handleMenuBack} />
            </div>
          </Spin>
        </Content>

        <FloatButton.BackTop>
          <div
            style={{
              height: 48,
              width: 48,
              borderRadius: "50%",
              background: `linear-gradient(135deg, ${COLOR.secondaryLight} 0%, ${COLOR.secondary} 100%)`,
              color: COLOR.primary,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              boxShadow: `0 4px 12px ${COLOR.secondary}66`,
              cursor: "pointer",
              transition: "all 0.3s",
              fontWeight: "bold",
            }}
          >
            <UpOutlined style={{ fontSize: 20 }} />
          </div>
        </FloatButton.BackTop>
      </Layout>
    </Layout>
  );
}

export default Main;
